import { getDefaultContactOptions } from './contactOptionshelper';
import {
  RECEIVE_TOPIC_INTENT_DATA_ERROR,
  RECEIVE_TOPIC_INTENT_DATA_RESPONSE,
  REQUEST_TOPIC_INTENT_DATA,
  RESET_TOPIC_INTENT_DATA,
  RECEIVED_RESP_FROM_IDI,
  REQ_RESP_FROM_IDI,
  RECEIVED_IDI_CONTACT_CHANNEL_OPTIONS_ERROR,
} from './ContactOptionsAction';

const initialState = {
  channels: getDefaultContactOptions(),
  isLoading: false,
  isIDILoading: false,
  fetchTopicError: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TOPIC_INTENT_DATA:
      return {
        ...state,
        isLoading: true,
        isIDILoading: true,
      };
    case RECEIVE_TOPIC_INTENT_DATA_RESPONSE:
      return {
        ...state,
        isLoading: false,
        isIDILoading: true,
        fetchTopicError: false,
        kanaCode: action.payload.kanaCode,
        formElements: action.payload.formElements,
      };
    case RECEIVE_TOPIC_INTENT_DATA_ERROR:
      return {
        ...state,
        isLoading: false,
        isIDILoading: false,
        fetchTopicError: true,
      };
    case RESET_TOPIC_INTENT_DATA:
      return {
        ...state,
        channels: getDefaultContactOptions(),
      };
    case REQ_RESP_FROM_IDI:
      return {
        ...state,
        isIDIServiceLoaded: false,
        isIDILoading: true,
      };
    case RECEIVED_RESP_FROM_IDI:
      return {
        ...state,
        IDIError: false,
        isIDIServiceLoaded: true,
        isIDILoading: false,
        channels: action.payload,
      };
    case RECEIVED_IDI_CONTACT_CHANNEL_OPTIONS_ERROR:
      return {
        ...state,
        IDIError: true,
        isIDIServiceLoaded: true,
        isIDILoading: false,
      };
    default:
      return { ...state };
  }
};

export default reducer;
